module.exports = __webpack_public_path__ + "static/icons/icon-new-tab-7b8e8e156cffd24fd29c9f0ebc3742c9.svg";